import {useDispatch, useSelector} from 'react-redux';
import {fullScreenModalAction, modalSetPosSizeAction, toggleModalAction} from 'module/Modal/action/ModalAction';
import {useCallback} from 'react';
import {ModalKey} from 'module/Modal/type/ModalKey';
import {selModalStateGen} from 'module/Modal/selector/ModalSelector';
import {ModalPosition, ModalSize} from 'module/Modal/reducer/ModalType'

export const useModal = (modalKey: ModalKey) => {
	const {open, position, size, fullScreen} = useSelector(selModalStateGen(modalKey))
	const dispatch = useDispatch()
	const onClose = useCallback(() => {
		dispatch(toggleModalAction({modalKey, open: false}))
	}, [modalKey])
	const onChangedPositionSize = useCallback((position?: ModalPosition, size?: ModalSize) => {
		dispatch(modalSetPosSizeAction({modalKey, position, size}))
	}, [modalKey])
	const onFullScreen = useCallback(() => dispatch(fullScreenModalAction({modalKey, fullScreen: !fullScreen})), [modalKey, fullScreen])
	return {open, fullScreen, position, size, onClose, onChangedPositionSize, onFullScreen}
}